// Price calculation utility for tool rentals

/**
 * Calculate price per unit based on rental type
 * @param {Object} tool - Tool object with pricing info
 * @param {string} rentalType - '4hours', 'day', 'week', or 'night'
 * @returns {number} - Price per unit in UAH
 */
export const getPricePerUnit = (tool, rentalType) => {
  if (rentalType === '4hours') return tool.pricePer4Hours;
  if (rentalType === 'night') return tool.pricePerNight;
  if (rentalType === 'week') return tool.pricePerWeek;
  return tool.pricePerDay;
};

/**
 * Calculate total price for a rental
 * @param {Object} tool - Tool object with pricing info
 * @param {string} rentalType - '4hours', 'day', 'week', or 'night'
 * @param {number} duration - Duration in units (hours/days)
 * @returns {number} - Total price in UAH
 */
export const calculateTotalPrice = (tool, rentalType, duration) => {
  if (rentalType === 'night') return tool.pricePerNight;
  if (rentalType === 'week') {
    // Base weekly price + extra days at daily rate
    const extraDays = duration > 7 ? duration - 7 : 0;
    return tool.pricePerWeek + (extraDays * tool.pricePerDay);
  }
  const pricePerUnit = getPricePerUnit(tool, rentalType);
  return pricePerUnit * duration;
};

/**
 * Get the maximum duration allowed for a rental type
 * @param {string} rentalType - '4hours', 'day', 'week', or 'night'
 * @returns {number} - Maximum duration
 */
export const getMaxDuration = (rentalType) => {
  if (rentalType === '4hours') return 5;
  if (rentalType === 'night') return 1;
  return 30; // days and weeks
};

/**
 * Get the default duration for a rental type
 * @param {string} rentalType - '4hours', 'day', 'week', or 'night'
 * @returns {number} - Default duration
 */
export const getDefaultDuration = (rentalType) => {
  if (rentalType === 'week') return 7;
  return 1;
};
